// extracted by mini-css-extract-plugin
export var icon = "_4z-1";
export var subtext = "_4z-0";